/**
 * product-hover-zoom.js
 *
 * Inline hover zoom for the product media gallery.
 * Hovering over an image zooms it within its own container (no dialog/popup).
 * Disabled automatically on touch devices.
 */

const ZOOM_SCALE = 2.2;
const DISABLE_ON_TOUCH = window.matchMedia('(pointer: coarse)');

function attachHoverZoom(slide) {
  if (DISABLE_ON_TOUCH.matches) return;
  if (!slide.classList.contains('product-media-container--image')) return;

  const img = slide.querySelector('img.product-media__image');
  if (!img) return;

  // Prevent double-attaching
  if (slide.dataset.hoverZoom) return;
  slide.dataset.hoverZoom = 'true';

  function onMove(e) {
    const rect = slide.getBoundingClientRect();
    const xPct = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
    const yPct = Math.min(Math.max((e.clientY - rect.top) / rect.height, 0), 1);
    img.style.transformOrigin = `${xPct * 100}% ${yPct * 100}%`;
    img.style.transform = `scale(${ZOOM_SCALE})`;
    img.style.willChange = 'transform';
  }

  function onLeave() {
    img.style.transform = '';
    img.style.transformOrigin = '';
    img.style.willChange = '';
  }

  slide.addEventListener('mousemove', onMove);
  slide.addEventListener('mouseleave', onLeave);
}

function initHoverZoom(root = document) {
  root.querySelectorAll('slideshow-slide.product-media-container--image').forEach(attachHoverZoom);
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', () => initHoverZoom());

// Re-init after variant updates (Shopify morphs the DOM)
document.addEventListener('shopify:section:load', () => initHoverZoom());

// Re-run after any section renderer / quick-buy DOM swap via MutationObserver
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (node.tagName === 'SLIDESHOW-SLIDE') {
        attachHoverZoom(node);
      } else {
        node.querySelectorAll?.('slideshow-slide.product-media-container--image')
          .forEach(attachHoverZoom);
      }
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });
